(() => {
  const supportedCodes = new Set(['DAVE20', 'ASPREY']);
  const params = new URLSearchParams(window.location.search);
  const code = (params.get('code') || '').trim().toUpperCase();

  if (!supportedCodes.has(code)) return;

  const sessionKey = `dave-asprey-discount-${code}`;

  // Apply the Shopify discount once per browser session, then return to this
  // campaign URL so the code can be shown on the product cards.
  if (!window.sessionStorage.getItem(sessionKey)) {
    window.sessionStorage.setItem(sessionKey, 'true');
    const redirect = `${window.location.pathname}?code=${encodeURIComponent(code)}`;
    window.location.replace(`/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(redirect)}`);
    return;
  }

  document.querySelectorAll('.card-information').forEach((cardInformation) => {
    const details = cardInformation.querySelector('.product-parameters');
    const price = cardInformation.querySelector('.wide-price');
    const insertionPoint = details || price;

    if (!insertionPoint || cardInformation.querySelector('.dave-asprey-discount-code')) return;

    const message = document.createElement('p');
    message.className = 'dave-asprey-discount-code';
    message.textContent = `Discount code ${code} applied at checkout`;
    insertionPoint.insertAdjacentElement('afterend', message);
  });
})();
